import $ from 'jquery';
import Headroom from 'headroom.js';

// Headroom settings
const settings = {
  // vertical offset in px before element is first unpinned
  offset: 120,
  // scroll tolerance in px before state changes
  tolerance: 5, // or {down: 0, up: 0},
  // css classes to apply
  classes: {
    // when element is initialised
    initial: 'headroom',
    // when scrolling up
    pinned: 'locked',
    // when scrolling down
    unpinned: 'unlocked',
    // when above offset
    top: 'top',
    // when below offset
    notTop: 'not-top',
    // when at bottom of scoll area
    bottom: 'bottom',
    // when not at bottom of scroll area
    notBottom: 'not-bottom',
  },
  // callback when pinned, `this` is headroom object
  onPin() {
    $(document.body).addClass('locked').removeClass('unlocked');
  },
  // callback when unpinned, `this` is headroom object
  onUnpin() {
    $(document.body).addClass('unlocked').removeClass('locked');
  },
  // callback when above offset, `this` is headroom object
  onTop() {
    $(document.body).addClass('top').removeClass('not-top');
  },
  // callback when below offset, `this` is headroom object
  onNotTop() {
    $(document.body).addClass('not-top').removeClass('top');
  },
  // callback at bottom of page, `this` is headroom object
  onBottom() {},
  // callback when moving away from bottom of page, `this` is headroom object
  onNotBottom() {},
};

export default class Header {
  constructor(element) {
    // Check if (.cc-window is set)
    const $messages = $('.cc-window.cc-top.fixed-top:not(.cc-invisible)').not('.cc-invisible');
    if ($messages.length > 0) {
      // Get height of all messages and fix the offset.
      let total = 0;
      $messages.each(function () {
        total += $(this).outerHeight();
      });
      settings.offset += total;
    }

    // Create a new Headroom instance
    const headroom = new Headroom(element, settings);
    // Initialize this Headroom instance
    headroom.init();
    // Return back the new instance
    return headroom;
  }
}
